import classNames from 'classnames';
import React, { JSX } from 'react';
import { Asset } from './types';

export function useGetStyledAssetConversions() {
  return (asset: Asset): JSX.Element => (
    <p className={classNames('asset-conversions')}>
      {asset.PerformanceMetrics.ConversionsCredit}
    </p>
  );
}

